module.exports = __webpack_public_path__ + "static/media/Montserrat-LightItalic.bc4d475c.woff";